import msalInstance, { scope } from "../authConfig";

class AccountService {

    private isInitialized = false;

    /**
     * Ensures MSAL is initialized before any API calls.
     */
    private async ensureMSALInitialized(): Promise<void> {
        if (!this.isInitialized) {
            try {
                await msalInstance.initialize(); // Ensure MSAL is initialized
                this.isInitialized = true;
            } catch (error) {
                console.error("Failed to initialize MSAL instance", error);
                throw error;
            }
        }
    }

    /**
     * Retrieves the access token using MSAL.
     * @returns {Promise<string | null>} The access token if it exists, otherwise null.
     */
    async getAccessToken(): Promise<string | null> {
        await this.ensureMSALInitialized(); // Ensure MSAL is initialized

        const account = msalInstance.getAllAccounts()[0];
        
        if (!account) {
            return null;
        }

        try {
            const token = await msalInstance.acquireTokenSilent({
                account: account,
                scopes: [scope]
            });

            return token.accessToken;
        } catch (error) {
            console.error("Failed to acquire token silently", error);
            return null;
        }
    }

}

const accountService = new AccountService();
export default accountService;